module.exports = __webpack_public_path__ + "img/58.09607b19.svg";